<template lang="html">
	<a
		href="#"
		@click.prevent="$bus.$emit('onboardingPrevPage')"
		class="omapi-link-arrow-before omapi-wizard-back"
		:disabled="disabled"
		ref="el"
	>
		Go Back
	</a>
</template>
<script lang="js">
export default {
	props : {
		disabled : Boolean,
	},
}
</script>
